module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-4.19afe1e9.png";